import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MergeRejectPopupComponent } from '../merge-reject-popup/merge-reject-popup.component';
import { ReviewDataService } from '../../services/raintree/Transmission/review-data.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-merge-accept-popup',
  standalone: true,
  imports: [MatDialogModule, FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './merge-accept-popup.component.html',
  styleUrl: './merge-accept-popup.component.scss',
})
export class MergeAcceptPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public _reviewDataService: ReviewDataService,
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private dialogRef: MatDialogRef<MergeAcceptPopupComponent>
  ) {}
  count: number = 0;
  checkCount: any = 0;
  isApproved: boolean = false;
  comments = new FormControl('');
  ngOnInit(): void {
    this.data.fc.map((item: any) => {
      console.log(item);
      return { ...item, isApproved: !this.isApproved };
    });
    this.comments.valueChanges.subscribe((item: any) => {
      this.count = item.length;
    });
  }
  onCheckboxChange(row: any) {
    console.log('data', this.data);

    this.data.fc.map((item: { memberCode: any; isApproved: boolean }) => {
      console.log(item, row);
      if (item.memberCode == row.memberCode) {
        item.isApproved = !item.isApproved;
        if (item.isApproved) this.checkCount++;
        else this.checkCount--;
      }
    });
  }
  onRejectClick() {
    this.dialog.open(MergeRejectPopupComponent, {
      data: { data: this.data, comment: this.comments.value },
    });
    this.dialogRef.close();
  }

  reqBody: any = {};

  onApproveClick() {
    if (this.comments.value?.length == 0) this.toaster.error('Enter Comments');
    else {
      const queryParams: any = { ...this.route.snapshot.queryParams };
      this.reqBody = this.data.fc.map(
        (obj: { isApproved: any; memberCode: any }) => {
          if (obj.isApproved) {
            this.checkCount++;
          }

          return {
            isApproved: obj.isApproved,
            memberCode: obj.memberCode,
          };
        }
      );
      this.reqBody = {
        reviewFCArr: [...this.reqBody],
        rejectReason: this.comments.value,
        uiState: queryParams['state'],
        uiDistrict: queryParams['district'],
      };

      console.log(this.reqBody, this.data.memKey, 'req body');
      if (this.checkCount >= 1) {
        this._reviewDataService
          .approveMergeData(this.data.memKey, this.reqBody)
          .subscribe({
            next: (response: any) => {
              console.log(response);
              if (!response.error)
                this.dialog.open(DpSuccessMessageComponent, {
                  data: {
                    mainHeading: 'Accepted data successfully',
                    subHeading:
                      'Please go back to review page to approve/reject more',
                    buttonValue: 'Finish',
                  },
                });
              this.dialogRef.close(true);
            },
            error: (error) => {
              console.log(error);
              this.toaster.error(error);
            },
          });
      }
    }
  }
}
